/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListPhoneCompany } from '../../models/api-response-list-phone-company';

export interface GetCompanyNumbers$Params {
  companyId: string;
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getCompanyNumbers(http: HttpClient, rootUrl: string, params: GetCompanyNumbers$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPhoneCompany>> {
  const rb = new RequestBuilder(rootUrl, getCompanyNumbers.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListPhoneCompany>;
    })
  );
}

getCompanyNumbers.PATH = '/v1/api/ui/meta-pricing-analytics/numbers/{companyId}';
